import { render, staticRenderFns } from "./internationalAirOrder.vue?vue&type=template&id=073ce8fe&scoped=true&"
import script from "./internationalAirOrder.vue?vue&type=script&lang=js&"
export * from "./internationalAirOrder.vue?vue&type=script&lang=js&"
import style0 from "./internationalAirOrder.vue?vue&type=style&index=0&id=073ce8fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ce8fe",
  null
  
)

export default component.exports